import { render, staticRenderFns } from "./ReferenceExamplesEditor.vue?vue&type=template&id=49c6547e&scoped=true&"
import script from "./ReferenceExamplesEditor.vue?vue&type=script&lang=js&"
export * from "./ReferenceExamplesEditor.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceExamplesEditor.vue?vue&type=style&index=0&id=49c6547e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6547e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
